import React, { useRef } from "react";
import { Form, Field, Formik } from 'formik';
import * as Yup from 'yup';
import SelectField from './CustomField/SelectField';

export default function SelectDisplayOptionStep(props) {
  const formState = useRef();
  const storage = JSON.parse(window.lsSession.getItem(`chatbot-${props.formType}`))
  const builtDate = storage.built_date
  const initialValues = props.initialValues

  const customValidate = () => {
    if (props.name == "purchase_year") {
      return Yup.object().shape({
        purchase_year: Yup.number().required("購入時期を入力してください。")
                          .min(builtDate, "購入時期は築年数より大きい年を選択してください。"),
      });
    } else {
      return props.validate
    }
  }

  const handleTriggerNextStep = async(values) => {
    await formState.current.setFieldTouched();
    await formState.current.validateForm()

    if (!formState.current.isValid) return;

    const newObj = {...storage, ...values}
    const storageStr = JSON.stringify(newObj)
    window.lsSession.setItem(`chatbot-${props.formType}`, storageStr)
    props.triggerNextStep({ trigger: props.trigger, value: values, replaceAll: props.step.id })
  }

  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValues}
      validationSchema={customValidate()}
      validateOnChange={false}
      validateOnBlur={false}
      onSubmit={handleTriggerNextStep}
    >
      {(formikProps) => {
        const { handleSubmit } = formikProps;
        formState.current = formikProps;

        return (
          <Form onSubmit={handleSubmit}>
            <div className="selectOption">
              <div className="titleSelect">{props.title}</div>
              <Field name={props.name} component={SelectField} options={props.options} blank="選択してください" display_options={props.renderOption} />
            </div>
            <button type="submit" className="btnSubmit">
              決定
            </button>
          </Form>
        )
      }}
    </Formik>
  )
}
